import React, { Component } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { HomepageContext } from "context/homepageProvider";
import "scss/components/homepage/googleMapsDevices.scss";

import green_pin from "assets/map_icon/green_pin.png";
import red_pin from "assets/map_icon/red_pin.png";

export default class GoogleMapsDevicesIot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pinSize: null,
      model: "",
    };
  }

  render() {
    const containerStyle = {
      width: "100%",
      height: "450px",
    };

    const center = {
      lat: 13.736717,
      lng: 100.523186,
    };

    // console.log("Power:", this.props.power);
    return (
      <div className="googleMapsDevices">
        <LoadScript googleMapsApiKey="AIzaSyDynDZSFQuvMWZ8lafc1LarFWiUlavcM2Y">
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={6}
            onLoad={(map) => {
              this.setState({
                pinSize: new window.google.maps.Size(20, 30),
              });
            }}
          >
            {this.props.power === 1 ? (
              <Marker
                icon={{
                  url: green_pin,
                  scaledSize: this.state.pinSize,
                }}
                position={{
                  lat: parseFloat(this.props.lat),
                  lng: parseFloat(this.props.lng),
                }}
              />
            ) : (
              <Marker
                icon={{
                  url: red_pin,
                  scaledSize: this.state.pinSize,
                }}
                position={{
                  lat: parseFloat(this.props.lat),
                  lng: parseFloat(this.props.lng),
                }}
              />
            )}
          </GoogleMap>
        </LoadScript>
      </div>
    );
  }
}
GoogleMapsDevicesIot.contextType = HomepageContext;
